module.exports = __webpack_public_path__ + "img/5.67d06028.jpg";